/**
 * 简体中文文本目录 - `community` 功能（论坛、主题、传奇殿堂）。键与
 * packages/@gamecodex/world-ui/src/features/community 中的
 * `t('community.*')` 调用相镜像。
 */
export const communityZhCN = {
  // CommunityPage
  'community.page.seoTitle': '社区',
  'community.page.seoDescription':
    '加入Grymwyrd社区：论坛、传说理论、游戏主持人工具、自创内容和传奇殿堂。',
  'community.page.eyebrow': '暗聚之地',
  'community.page.title': '社区',
  'community.page.intro':
    '分享战术、编织理论、展示自创内容，向着正史的顶峰攀升。你的每条贴子在永恒的暮光中获得金币和声望。',
  'community.page.loading': '信徒集结中…',
  'community.page.forumCategories': '论坛分类',
  'community.page.categoryStats': '{threads} 个主题 · {posts} 条贴子',
  'community.page.recentActivity': '最近活动',
  'community.page.liveFeed': '实时动态',
  'community.page.recentEmpty':
    '论坛今晚沉寂无声。发起讨论唤醒亡灵。',
  'community.page.hallOfLegends': '传奇殿堂',
  'community.page.hallBlurb': '最伟大的贡献者及其锻造进正史的角色。',
  'community.page.enterTheHall': '进入殿堂',
  'community.page.playerSpotlights': '玩家焦点',
  'community.page.summoningLegends': '召唤传奇…',
  'community.page.sampleNotice': '正在显示示例社区内容，实时论坛正在觉醒。',

  // FlagButton
  'community.flag.errorQueued':
    '无法立刻联系版主，但你的举报已排队待处理。',
  'community.flag.ariaLabel': '举报此贴进行版务审核',
  'community.flag.label': '举报',
  'community.flag.modalTitle': '向守卫者举报',
  'community.flag.successDelivered':
    '你的举报已送达版主。守卫者向你致谢。',
  'community.flag.close': '关闭',
  'community.flag.signInNotice':
    '你仍可描述问题，但举报需要登录才能送达版主。',
  'community.flag.whyFlagging': '你为什么举报此贴？',
  'community.flag.reason.spamOrAdvertising': '垃圾或广告',
  'community.flag.reason.harassmentOrAbuse': '骚扰或辱骂',
  'community.flag.reason.spoilersWithoutWarning': '未警告的剧透',
  'community.flag.reason.offTopic': '离题',
  'community.flag.reason.otherDescribeBelow': '其他（下方描述）',
  'community.flag.describeIssue': '描述问题',
  'community.flag.detailPlaceholder': '告诉守卫者哪里出错了…',
  'community.flag.cancel': '取消',
  'community.flag.reporting': '举报中…',
  'community.flag.submitReport': '提交举报',

  // ForumCategoryPage
  'community.category.seoTitle': '{name} — 论坛',
  'community.category.seoDescription': 'Grymwyrd 上 {name} 论坛中的讨论。',
  'community.category.breadcrumb': '社区',
  'community.category.entityTiedPrefix': '实体专属版 · 主题可能链接至',
  'community.category.encyclopediaEntries': '百科条目',
  'community.category.sampleNotice': '显示示例主题，实时论坛正在觉醒。',

  // HallOfLegendsPage
  'community.legends.seoTitle': '传奇殿堂',
  'community.legends.seoDescription':
    'Grymwyrd 最伟大的贡献者及其锻造进正史的角色。',
  'community.legends.breadcrumb': '社区',
  'community.legends.title': '传奇殿堂',
  'community.legends.intro':
    '此处汇聚永恒暮光的建筑师——言语成法的贡献者，以及被铭刻进正史的至爱角色。',
  'community.legends.loading': '燃亮烛火…',
  'community.legends.topContributors': '顶级贡献者',
  'community.legends.noContributors':
    '传奇尚未崭露。发贴、论证、创作以争得你的位置。',
  'community.legends.canonizedCharacters': '正史化角色',
  'community.legends.noCharacters':
    '尚无角色正史化。怪物图鉴等待下一场恐怖。',
  'community.legends.sampleNotice': '显示示例传奇，实时殿堂正在神圣化。',

  // NestedReplies
  'community.replies.replyBy': '{author} 的回复',
  'community.replies.reply': '回复',
  'community.replies.replyToPlaceholder': '回复给 {author}…',
  'community.replies.unlike': '取消赞此贴',
  'community.replies.like': '赞此贴',

  // PlayerSpotlight
  'community.spotlight.rep': '{rep} 声望',
  'community.spotlight.viewInEncyclopedia': '在百科中查看 {name}',

  // PostComposer
  'community.composer.placeholder': '将你的声音加入黑暗…',
  'community.composer.signInPrompt': '登录参与讨论，为你的言语赚取金币。',
  'community.composer.signInToReply': '登录以回复',
  'community.composer.youFallback': '你',
  'community.composer.saveError':
    '回复暂未能保存到服务器——仅在本地显示。',
  'community.composer.writeReply': '撰写回复',
  'community.composer.writePost': '撰写贴子',
  'community.composer.replyText': '回复文本',
  'community.composer.postText': '贴子文本',
  'community.composer.posting': '发布中…',
  'community.composer.postReply': '发布回复',
  'community.composer.post': '发布',
  'community.composer.cancel': '取消',
  'community.composer.coinsPerPost': '每贴 +{count} 金币',
  'community.composer.coinsEarned': '因贴子获得 +{count} 金币！',

  // ThreadItem
  'community.thread.pinned': '置顶主题',
  'community.thread.byPrefix': '由',
  'community.thread.repliesTitle': '{count} 条回复',
  'community.thread.likesTitle': '{count} 个赞',
  'community.thread.viewsTitle': '{count} 次浏览',
  'community.thread.entityEntry': '{type} 条目',

  // ThreadList
  'community.threadList.empty':
    '此处尚无讨论激起。成为第一个打破沉寂的声音。',

  // ThreadPage
  'community.threadPage.loading': '解封主题…',
  'community.threadPage.seoDescription': 'Grymwyrd 社区论坛中的讨论。',
  'community.threadPage.replyCount': '{count} 条回复',
  'community.threadPage.opened': '发起于 {time}',
  'community.threadPage.entityEntry': '{type} 条目',
  'community.threadPage.sampleNotice': '显示示例讨论，实时论坛正在觉醒。',
  'community.threadPage.openingPostBy': '首贴作者 {author}',
  'community.threadPage.repliesHeading': '回复',
  'community.threadPage.noReplies': '尚无回复。成为第一个应答者。',
  'community.threadPage.addYourReply': '添加你的回复',
} as const
